import { render, staticRenderFns } from "./TimeUpOverlay.vue?vue&type=template&id=0fa0bf71&scoped=true&"
import script from "./TimeUpOverlay.vue?vue&type=script&lang=js&"
export * from "./TimeUpOverlay.vue?vue&type=script&lang=js&"
import style0 from "./TimeUpOverlay.vue?vue&type=style&index=0&id=0fa0bf71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0bf71",
  null
  
)

export default component.exports